"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var pricing_1 = require("../../common/ui-selectors/video/pricing");
var pricing_2 = require("../../common/ui-selectors/channel/pricing");
var preview_types_1 = require("@wix/wix-vod-constants/dist/common/preview-types");
var preview_1 = require("../../common/ui-selectors/video/preview");
var channel_access_1 = require("./channel-access");
var live_1 = require("../../common/ui-selectors/video/live");
var video_origin_1 = require("../../common/ui-selectors/video/video-origin");
var pricing_3 = require("../../common/ui-selectors/channel/pricing");
var deal_info_helpers_1 = require("../../common/utils/deal-info-helpers");
function isLoggedIn(currentSiteUser) {
    return !lodash_1.isEmpty(currentSiteUser);
}
function isForMemberOnly(video) {
    return Boolean(video.memberOnly);
}
exports.isForMemberOnly = isForMemberOnly;
function isVideoExist(video) {
    return !live_1.isScheduledLive(video) && !live_1.isPendingLiveStream(video);
}
exports.isVideoExist = isVideoExist;
function isAccessAllowed(channel, video, currentSiteUser) {
    if (pricing_1.isFree(video)) {
        if (pricing_2.isSubscriptionEnabled(channel) && !video_origin_1.isExternalVideo(video)) {
            return pricing_2.isSubscribedTo(channel);
        }
        else if (pricing_3.isPricingPlanEnabled(channel) && !video_origin_1.isExternalVideo(video)) {
            return pricing_3.hasAccessToChannelByPricingPlan(channel);
        }
        else {
            return !isForMemberOnly(video) || isLoggedIn(currentSiteUser);
        }
    }
    return (pricing_1.isRented(video) ||
        pricing_1.isBought(video) ||
        channel_access_1.canAccessChannelWithSubscription(channel) ||
        channel_access_1.canAccessChannelByPricingPlan(channel));
    /* eslint-enable */
}
exports.isAccessAllowed = isAccessAllowed;
function isDownloadAllowed(channel, video, currentSiteUser) {
    if (isVideoExist(video)) {
        if (pricing_1.isFree(video)) {
            return !isForMemberOnly(video) || isLoggedIn(currentSiteUser);
        }
        else {
            return pricing_1.isBought(video) || channel_access_1.canAccessChannelWithSubscription(channel);
        }
    }
    return false;
}
exports.isDownloadAllowed = isDownloadAllowed;
function canAccessFullVideo(channel, video, currentSiteUser) {
    return (isVideoExist(video) && isAccessAllowed(channel, video, currentSiteUser));
}
exports.canAccessFullVideo = canAccessFullVideo;
// What user need to do to get access to full video
exports.FULL_ACCESS_ACTION_NAMES = {
    SIGN_IN: 'needs-sign-in',
    SUBSCRIBE: 'needs-subscription',
    BUY: 'need-to-buy',
    RENT: 'need-to-rent',
    BUY_OR_RENT: 'need-to-buy-or-rent',
    PRICING_PLAN: 'pricing-plan-enabled',
};
function getFullAccessActionName(channel, video, currentSiteUser) {
    var _a, _b;
    if (canAccessFullVideo(channel, video, currentSiteUser)) {
        return null;
    }
    if (isAccessAllowed(channel, video, currentSiteUser) &&
        (live_1.isScheduledLive(video) || live_1.isPendingLiveStream(video))) {
        return null;
    }
    if (pricing_3.isPricingPlanEnabled(channel)) {
        var pricingPlanInfo = deal_info_helpers_1.getPricingPlanInfo(channel.dealInfo);
        //channel.subscriptionOnly shows if purchase or rent of single videos in a channel is disabled.
        //this value common for subscription and pricing plans.
        //channel.subscriptionOnly - in V2, pricingPlanInfo?.required - in V3
        if (pricing_1.isFree(video)
            || channel.subscriptionOnly
            || ((_a = pricingPlanInfo) === null || _a === void 0 ? void 0 : _a.required)) {
            return exports.FULL_ACCESS_ACTION_NAMES.PRICING_PLAN;
        }
    }
    if (pricing_1.isFree(video) && pricing_2.isSubscriptionEnabled(channel)) {
        return pricing_2.isSubscribedTo(channel) ? null : exports.FULL_ACCESS_ACTION_NAMES.SUBSCRIBE;
    }
    if (pricing_1.isFree(video) && isForMemberOnly(video)) {
        return exports.FULL_ACCESS_ACTION_NAMES.SIGN_IN;
    }
    if (pricing_2.isSubscriptionEnabled(channel)) {
        var subscriptionInfo = deal_info_helpers_1.getSubscriptionPriceInfo(channel.dealInfo);
        //channel.subscriptionOnly shows if purchase or rent of single videos in a channel is disabled.
        //this value common for subscription and pricing plans.
        //channel.subscriptionOnly - in V2, subscriptionInfo?.required - in V3
        if (channel.subscriptionOnly || ((_b = subscriptionInfo) === null || _b === void 0 ? void 0 : _b.required)) {
            return exports.FULL_ACCESS_ACTION_NAMES.SUBSCRIBE;
        }
    }
    if (pricing_1.isRentEnabled(video) && pricing_1.isSaleEnabled(video)) {
        return exports.FULL_ACCESS_ACTION_NAMES.BUY_OR_RENT;
    }
    if (pricing_1.isRentEnabled(video)) {
        return exports.FULL_ACCESS_ACTION_NAMES.RENT;
    }
    if (pricing_1.isSaleEnabled(video)) {
        return exports.FULL_ACCESS_ACTION_NAMES.BUY;
    }
}
exports.getFullAccessActionName = getFullAccessActionName;
var AVAILABLE_VIDEO_TYPES;
(function (AVAILABLE_VIDEO_TYPES) {
    AVAILABLE_VIDEO_TYPES["FULL"] = "full-video";
    AVAILABLE_VIDEO_TYPES["TRAILER"] = "trailer";
    AVAILABLE_VIDEO_TYPES["FIRST_20_SEC"] = "preview";
    AVAILABLE_VIDEO_TYPES["LIVE_STREAMING"] = "live-streaming";
})(AVAILABLE_VIDEO_TYPES = exports.AVAILABLE_VIDEO_TYPES || (exports.AVAILABLE_VIDEO_TYPES = {}));
function getAvailableVideoType(channel, video, currentSiteUser) {
    if (canAccessFullVideo(channel, video, currentSiteUser)) {
        return live_1.isReadyLiveStream(video)
            ? AVAILABLE_VIDEO_TYPES.LIVE_STREAMING
            : AVAILABLE_VIDEO_TYPES.FULL;
    }
    if (pricing_1.isFree(video) && isForMemberOnly(video)) {
        return;
    }
    var previewType = preview_1.getPreviewType(video);
    if (preview_1.hasTrailer(video) && previewType === preview_types_1.PREVIEW_TYPES.TRAILER) {
        return AVAILABLE_VIDEO_TYPES.TRAILER;
    }
    if (previewType === preview_types_1.PREVIEW_TYPES.FIRST_20_SEC) {
        return AVAILABLE_VIDEO_TYPES.FIRST_20_SEC;
    }
}
exports.getAvailableVideoType = getAvailableVideoType;
function canPlayFullOrPreview(channel, video, currentSiteUser) {
    return Boolean(getAvailableVideoType(channel, video, currentSiteUser));
}
exports.canPlayFullOrPreview = canPlayFullOrPreview;
var OWNERSHIP_STATUSES;
(function (OWNERSHIP_STATUSES) {
    OWNERSHIP_STATUSES["YOU_BOUGHT_THIS"] = "user-bought-video";
    OWNERSHIP_STATUSES["YOU_RENTED_THIS"] = "user-rented-video";
})(OWNERSHIP_STATUSES = exports.OWNERSHIP_STATUSES || (exports.OWNERSHIP_STATUSES = {}));
exports.getOwnershipStatus = function (video) {
    if (pricing_1.isBought(video)) {
        return OWNERSHIP_STATUSES.YOU_BOUGHT_THIS;
    }
    if (pricing_1.isRented(video)) {
        return OWNERSHIP_STATUSES.YOU_RENTED_THIS;
    }
};
exports.getAvailabilityStatus = function (_a) {
    var channelData = _a.channelData, videoItem = _a.videoItem, currentSiteUser = _a.currentSiteUser;
    return (exports.getOwnershipStatus(videoItem) ||
        getFullAccessActionName(channelData, videoItem, currentSiteUser));
};
//# sourceMappingURL=video-access.js.map